/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Stage_Update_Error_ClientInputs */

const en_stage_update_error_client = /** @type {(inputs: Stage_Update_Error_ClientInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to update Client stage: ${i?.message}`)
};

const pt_br2_stage_update_error_client = /** @type {(inputs: Stage_Update_Error_ClientInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao atualizar etapa do cliente: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Failed to update Client stage: {message}" |
*
* @param {Stage_Update_Error_ClientInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const stage_update_error_client = /** @type {((inputs: Stage_Update_Error_ClientInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stage_Update_Error_ClientInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stage_update_error_client(inputs)
	return pt_br2_stage_update_error_client(inputs)
});